<template>
  <div>
    <v-container fill-height fluid>
    <v-row>
      <v-spacer></v-spacer>
      <v-btn
        v-if="can('create propagandists')"
        @click="showSchoolPropagandistModal(0)"
        color="primary"
        dark
        class="mb-2"
      >{{ $t("NEW") }}
      </v-btn>
    </v-row>
    </v-container>
    <v-data-table
      :headers="headers"
      :items="items"
      :server-items-length="totalItems"
      :no-data-text="$t('NO_DATA')"
      :no-results-text="$t('NO_DATA')"
      hide-default-footer
      :options.sync="pagination"
      :loading="loading"
      class="elevation-1"
    >

      <template v-slot:item.updated_at="{ item }">
            {{ item.updated_at | timeFormat }}
      </template>
      <template v-slot:item.actions="{ item }">
            <v-layout row wrap>
              <v-flex>
                <v-btn
                  v-if="can('delete schools')"
                  icon
                  color="red"
                  @click="deleteSchoolPropagandist(item.id)"
                >
                  <v-icon>cancel</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
      </template>
    </v-data-table>
    <Paginator
      :total-items="totalItems"
      :page.sync="pagination.page"
      :items-per-page.sync="pagination.itemsPerPage"
      @change="fetchSchoolPropagandists"
    />
  </div>
</template>

<script>
  import { mapActions } from 'vuex';

  import { propagandistsSchoolsService } from '../../../utils/services/propagandistsSchools.service';
  import SchoolPropagandistModal from '../../modals/Propagandists/SchoolPropagandistModal';
  import Paginator from '../../shared/Paginator';

  export default {
    name: 'PropagandistSchoolDetails',
    components: { Paginator },
    props: {
      propagandist: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        loading: false,
        items: [],
        totalItems: 0,
        pagination: {
          page: 1,
          itemsPerPage: 10,
          sortDesc: [false],
          sortBy: ['school_name'],
        },
        headers: [
          {
            text: this.$t('fields.school'),
            align: 'left',
            value: 'school_name',
          },
          { text: this.$t('fields.code'), value: 'code' },
          { text: this.$t('fields.province'), value: 'province' },
          { text: this.$t('fields.city'), value: 'city' },
          { text: this.$t('fields.address'), value: 'street' },
          { text: this.$t('fields.email'), value: 'email' },
          { text: this.$t('fields.phone'), value: 'phone' },
          { text: this.$t('fields.actions'), value: 'actions', sortable: false, align: 'center' },
        ],
      };
    },
    computed: {
      requestFilters() {
        const filters = {};
        if (this.pagination.sortBy.length === 1 && this.pagination.sortDesc.length === 1) {
          const { sortBy, sortDesc } = this.pagination;
          filters.sortBy = sortBy;
          filters.sortDesc = sortDesc;
        }
        return filters;
      },
    },
    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('modal', ['showModal', 'hideModal']),
      ...mapActions('alert', ['showToast']),

      async showSchoolPropagandistModal(id) {
        this.showModal({
          component: SchoolPropagandistModal,
            data: {
              stored: {
                id,
                propagandist_id: this.propagandist.id,
              },
          },
          options: {
            title: this.$t('SCHOOL'),
            onSave: (
              form,
              error,
            ) => propagandistsSchoolsService.save(form)
            .then(() => {
              this.fetchSchoolPropagandists(this.pagination.page);
              this.hideModal({});
              this.showToast({ type: 'success', message: this.$t('SAVED') });
            })
            .catch(error => {
              this.handleError(error, this.errors);
            })
            .finally(() => {
              this.fetchSchoolPropagandists(this.pagination.page);
            }),
          },
        });
      },

      async fetchSchoolPropagandists(forcePage) {
        this.loading = true;
        const { page, itemsPerPage } = this.pagination;
        return propagandistsSchoolsService.index(this.propagandist.id, {
          page: page || forcePage || 1,
          itemsPerPage,
          filters: this.requestFilters,
        })
        .then((response) => {
            this.items = response.data.data;
            this.totalItems = response.data.meta.total;
            this.pagination = this.getPagination(
              response.data.meta,
              { oldPagination: this.pagination, forcePage },
            );
        })
        .catch(error => {
          this.handleError(error, this.errors);
        })
        .finally(() => {
          this.loading = false;
        });
      },

      async deleteSchoolPropagandist(id) {
          this.showConfirm({
            onConfirm: () => {
              this.loading = true;
              return propagandistsSchoolsService.remove(this.propagandist.id, id)
              .then(() => {
                this.showToast({ type: 'success', message: this.$t('DELETED') });
                this.fetchSchoolPropagandists(this.pagination.page);
              })
              .catch(error => {
                this.handleError(error, this.errors);
              })
              .finally(() => {
                this.loading = false;
              });
            },
          });
      },
    },
    async created() {
      await this.fetchSchoolPropagandists();
    },
  };
</script>
